import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import moment from 'moment';
import { setLoading } from './LoadingSlice'; // Assuming this is correct
import axios from 'axios';
import Unauthorized from '../Admin/Unauthorized';
import { ToastContainer,toast } from 'react-toastify';
import BaseUrl from '../../BaseUrl';
const headers = Unauthorized.Actionsauthorized();
const API_BASE_URL =BaseUrl.consultationurl
const laburl =BaseUrl.labsurl

export const updatePatientServicesResults = createAsyncThunk(
    'labTestUpdates/updatePatientServices',
    async (payload, { dispatch, rejectWithValue }) => {
        dispatch(setLoading(true));
        try {
            
            const url = `${laburl}PatientServices`;
            const response = await axios.put(url, payload);
            
            return response.data; 
        } catch (error) {
            console.error('Error updating patient services:', error.response?.data || error.message);
            return rejectWithValue(error.response?.data?.Message || 'Failed to update lab service results');
        } finally {
            dispatch(setLoading(false));
        }
    }
);

export const updatePatientPackagesStatus = createAsyncThunk(
    'labTestUpdates/updatePatientPackages',
    async (payload, { dispatch, rejectWithValue }) => {
        dispatch(setLoading(true));
        try {
            const url = `${laburl}PatientPackages`;
            const response = await axios.put(url, payload,);
           
            return response.data; 
        } catch (error) {
            console.error('Error updating patient packages:', error.response?.data || error.message);
            return rejectWithValue(error.response?.data?.Message || 'Failed to update lab package status');
        } finally {
            dispatch(setLoading(false));
        }
    }
);


export const fetchLabTestServicesMaster = createAsyncThunk(
    'labTestUpdates/fetchServicesMaster',
    async (_, { dispatch, rejectWithValue }) => {
        dispatch(setLoading(true));
        try {
            const url = `${laburl}LabTestServices`;
            const response = await axios.get(url, { headers: headers });
            
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.Message || 'Failed to fetch lab test services master data');
        } finally {
            dispatch(setLoading(false));
        }
    }
);

export const fetchLabTestPackagesMaster = createAsyncThunk(
    'labTestUpdates/fetchPackagesMaster',
    async (_, { dispatch, rejectWithValue }) => {
        dispatch(setLoading(true));
        try {
            const url = `${laburl}Packages`;
            const response = await axios.get(url, { headers: headers }); 
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.Message || 'Failed to fetch lab test packages master data');
        } finally {
            dispatch(setLoading(false));
        }
    }
);

// --- NEW Thunk for Package Services Master Data (Crucial for filtering) ---
export const fetchPackageServicesMaster = createAsyncThunk(
    'labTestUpdates/fetchPackageServicesMaster',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const url = `${laburl}PackageServices`;
            const response = await axios.get(url, { headers: headers }); 
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.Message || 'Failed to fetch package services master data');
        }
    }
);

// --- Thunk for Consultation List (No Change) ---
export const getConsultationByDateAndStatus = createAsyncThunk(
    'labTestUpdates/fetchConsultations',
    async ({ startDate, status }, { dispatch, rejectWithValue }) => {
        dispatch(setLoading(true));
        try {
            if (!startDate || !status) {
                return rejectWithValue("StartDate and Status are required for fetching consultations.");
            }
            const url = `${API_BASE_URL}Consultations/ConsultationListByDateAndStatus?StartDate=${startDate}&Status=${status}`;
            const response = await axios.get(url, { headers: headers });
            return response.data.Consultations;
        } catch (error) {
            return rejectWithValue(error.response?.data?.Message || 'Failed to fetch consultations from API');
        } finally {
            dispatch(setLoading(false));
        }
    }
);

// --- Thunks for Patient-Specific Test Bookings (No Change) ---

export const getPatientPackagesByConsultationId = createAsyncThunk(
    'labTestUpdates/fetchPatientPackages',
    async (consultationId, { dispatch, rejectWithValue }) => {
        try {
            const url = `${laburl}PatientPackages/GetPackagesByConsultID?CID=${consultationId}`;
            const response = await axios.get(url, { headers: headers });
            
            return response.data; // Array of patient packages
        } catch (error) {
            return rejectWithValue(error.response?.data?.Message || 'Failed to fetch patient packages');
        }
    }
);

export const getPatientServicesByConsultationId = createAsyncThunk(
    'labTestUpdates/fetchPatientServices',
    async (consultationId, { rejectWithValue }) => {
        try {
            const url = `${laburl}PatientServices/GetServicesByConsultID?CID=${consultationId}`;
            const response = await axios.get(url, { headers: headers });
            
            return response.data; // Array of patient services
        } catch (error) {
            return rejectWithValue(error.response?.data?.Message || 'Failed to fetch patient services');
        }
    }
);

// --- UPDATED Thunk to Fetch and Merge All Test Data (Core Fixes) ---

export const getTestsForConsultation = createAsyncThunk(
    'labTestUpdates/fetchTestsForConsultation',
    async (consultationId, { getState, dispatch, rejectWithValue }) => {
        const { labTestUpdates } = getState();
        const masterServices = labTestUpdates.labTestServicesMaster;
        const masterPackages = labTestUpdates.labTestPackagesMaster;
        const packageServicesMaster = labTestUpdates.packageServicesMaster;

        try {
            // 1. Fetch patient's booked services and packages
            const [patientServicesResponse, patientPackagesResponse] = await Promise.all([
                dispatch(getPatientServicesByConsultationId(consultationId)),
                dispatch(getPatientPackagesByConsultationId(consultationId))
            ]);

            const patientServices = patientServicesResponse.payload || [];
            const patientPackages = patientPackagesResponse.payload || [];
            
            if (patientServicesResponse.meta.rejected || patientPackagesResponse.meta.rejected) {
                return rejectWithValue("Failed to fetch patient's booked tests from the API.");
            }

            // 2. Prepare Master Data Maps
            const serviceMasterMap = masterServices.reduce((acc, service) => {
                acc[service.id] = service;
                return acc;
            }, {});

            const packageMasterMap = masterPackages.reduce((acc, pkg) => {
                acc[pkg.id] = pkg;
                return acc;
            }, {});

            const packageServiceMap = packageServicesMaster.reduce((acc, ps) => {
                if (!acc[ps.packageId]) {
                    acc[ps.packageId] = [];
                }
                // Map: PackageId -> Array of ServiceIds
                acc[ps.packageId].push(ps.serviceId);
                return acc;
            }, {});

            // 3. De-duplicate Patient Packages & Collect all Service IDs in packages
            const bookedPackageServiceIds = new Set();
            const uniquePatientPackagesMap = new Map(); // Key: packageId, Value: PatientPackage object

            patientPackages.forEach(pkg => {
                // Collect all service IDs linked to any booked package (for filtering standalone services)
                const serviceIds = packageServiceMap[pkg.packageId] || [];
                serviceIds.forEach(id => bookedPackageServiceIds.add(id));
                
                // Keep only the first instance of each unique packageId
                if (!uniquePatientPackagesMap.has(pkg.packageId)) {
                    uniquePatientPackagesMap.set(pkg.packageId, pkg);
                }
            });

            const uniquePatientPackages = Array.from(uniquePatientPackagesMap.values());
            
            // 4. Map Patient Service to PatientServiceId for easy lookup (CRITICAL for saving)
            const patientServiceMap = patientServices.reduce((acc, ps) => {
                // Key: ServiceId, Value: PatientService object
                acc[ps.serviceId] = ps;
                return acc;
            }, {});

            // 5. Merge Patient Services (Standalone Only) with Master Data
            const mergedServices = patientServices
                .filter(patientService => 
                    // Keep services that are NOT part of ANY booked package
                    !bookedPackageServiceIds.has(patientService.serviceId)
                )
                .map(patientService => {
                    const master = patientService.labtest || serviceMasterMap[patientService.serviceId];
                    if (!master) return null;

                    return {
                        TestId: master.id, // This is the Service ID
                        TestName: master.serviceName,
                        MinValue: master.minVal,
                        MaxValue: master.maxVal,
                        ToxicValue: master.toxicVal,
                        // Ensure 0 is treated as no result unless it's explicitly entered
                        ActualResult: patientService.result !== 0 ? patientService.result?.toString() : '', 
                        PatientServiceId: patientService.id // <-- CRITICAL: Unique record ID
                    };
                })
                .filter(Boolean);

            // 6. Merge Patient Packages with Master Data (Using de-duplicated list)
            const mergedPackages = uniquePatientPackages
                .map(patientPackage => {
                    const masterPackage = packageMasterMap[patientPackage.packageId];
                    if (!masterPackage) return null;

                    const serviceIdsInPackage = packageServiceMap[masterPackage.id] || [];
                    
                    const testsInPackage = serviceIdsInPackage.map(serviceId => {
                        const testMaster = serviceMasterMap[serviceId]; 
                        if (!testMaster) return null;

                        // Find the patient service record using the map
                        const patientTestRecord = patientServiceMap[serviceId];
                        
                        // NOTE: If the patientTestRecord is missing, it means the service 
                        // in the package was NOT booked (which shouldn't happen, but guarded here).
                        if (!patientTestRecord) return null; 

                        return {
                            TestId: testMaster.id,
                            TestName: testMaster.serviceName,
                            MinValue: testMaster.minVal,
                            MaxValue: testMaster.maxVal,
                            ToxicValue: testMaster.toxicVal,
                            ActualResult: patientTestRecord.result !== 0 ? patientTestRecord.result?.toString() : '',
                            PatientServiceId: patientTestRecord.id // <-- CRITICAL: Unique record ID
                        };
                    }).filter(Boolean);

                    return {
                        PackageId: masterPackage.id,
                        PackageName: masterPackage.name,
                        Tests: testsInPackage,
                        // Use the ID of the patient's booked package for keying/identification
                        PatientPackageId: patientPackage.id 
                    };
                })
                .filter(Boolean);

            // 7. Return the merged structure
            return {
                services: mergedServices,
                packages: mergedPackages,
            };

        } catch (error) {
            console.error('Error fetching/merging lab tests:', error);
            return rejectWithValue(error.message || 'Failed to fetch and process lab tests');
        }
    }
);


const initialState = {
    consultations: [],
    loading: false,
    error: null,
    currentFilters: {
        date: moment().format('YYYY-MM-DD'),
        status: 'Completed',
    },
    selectedConsultationTests: {
        services: [],
        packages: [],
    },
    loadingTests: false,
    errorTests: null,

    // NEW STATE FOR MASTER DATA
    labTestServicesMaster: [],
    loadingServicesMaster: false,
    errorServicesMaster: null,

    labTestPackagesMaster: [],
    loadingPackagesMaster: false,
    errorPackagesMaster: null,
    
    // NEW STATE: Package to Service Mapping
    packageServicesMaster: [],
    loadingPackageServicesMaster: false,
    errorPackageServicesMaster: null,
};


const labTestUpdatesSlice = createSlice({
    name: 'labTestUpdates',
    initialState,
    reducers: {
        setConsultationFilters: (state, action) => {
            state.currentFilters = { ...state.currentFilters, ...action.payload };
        },
        clearTestDialogState: (state) => {
            state.selectedConsultationTests = { services: [], packages: [] };
            state.errorTests = null;
        }
    },
    extraReducers: (builder) => {
        // --- Consultation List ---
        builder
            .addCase(getConsultationByDateAndStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getConsultationByDateAndStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.consultations = action.payload;
            })
            .addCase(getConsultationByDateAndStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.consultations = [];
            })
        // --- Master Services ---
            .addCase(fetchLabTestServicesMaster.pending, (state) => {
                state.loadingServicesMaster = true;
            })
            .addCase(fetchLabTestServicesMaster.fulfilled, (state, action) => {
                state.loadingServicesMaster = false;
                state.labTestServicesMaster = action.payload;
            })
            .addCase(fetchLabTestServicesMaster.rejected, (state, action) => {
                state.loadingServicesMaster = false;
                state.errorServicesMaster = action.payload || action.error.message;
            })
        // --- Master Packages ---
            .addCase(fetchLabTestPackagesMaster.pending, (state) => {
                state.loadingPackagesMaster = true;
            })
            .addCase(fetchLabTestPackagesMaster.fulfilled, (state, action) => {
                state.loadingPackagesMaster = false;
                state.labTestPackagesMaster = action.payload;
            })
            .addCase(fetchLabTestPackagesMaster.rejected, (state, action) => {
                state.loadingPackagesMaster = false;
                state.errorPackagesMaster = action.payload || action.error.message;
            })
        // --- Master Package Services ---
            .addCase(fetchPackageServicesMaster.pending, (state) => {
                state.loadingPackageServicesMaster = true;
            })
            .addCase(fetchPackageServicesMaster.fulfilled, (state, action) => {
                state.loadingPackageServicesMaster = false;
                state.packageServicesMaster = action.payload;
            })
            .addCase(fetchPackageServicesMaster.rejected, (state, action) => {
                state.loadingPackageServicesMaster = false;
                state.errorPackageServicesMaster = action.payload || action.error.message;
            })
        // --- Fetch Consultation Tests ---
            .addCase(getTestsForConsultation.pending, (state) => {
                state.loadingTests = true;
                state.errorTests = null;
                state.selectedConsultationTests = initialState.selectedConsultationTests; // Clear previous data
            })
            .addCase(getTestsForConsultation.fulfilled, (state, action) => {
                state.loadingTests = false;
                state.selectedConsultationTests = action.payload;
            })
            .addCase(getTestsForConsultation.rejected, (state, action) => {
                state.loadingTests = false;
                state.errorTests = action.payload || action.error.message;
                state.selectedConsultationTests = initialState.selectedConsultationTests;
            })
        // --- Save Patient Services Results ---
            .addCase(updatePatientServicesResults.pending, (state) => {
                // Using loadingTests, but could be a dedicated saveLoading flag
                // state.loadingTests = true; 
                state.errorTests = null;
            })
            .addCase(updatePatientServicesResults.fulfilled, (state, action) => {
                // state.loadingTests = false;
                // Success action can be empty, as the component re-fetches the list
            })
            .addCase(updatePatientServicesResults.rejected, (state, action) => {
                // state.loadingTests = false;
                state.errorTests = action.payload || action.error.message;
            })
        // --- Save Patient Packages Status ---
            .addCase(updatePatientPackagesStatus.pending, (state) => {
                // state.loadingTests = true; 
                state.errorTests = null;
            })
            .addCase(updatePatientPackagesStatus.fulfilled, (state, action) => {
                // state.loadingTests = false;
            })
            .addCase(updatePatientPackagesStatus.rejected, (state, action) => {
                // state.loadingTests = false;
                state.errorTests = action.payload || action.error.message;
            });
    },
});

export const { setConsultationFilters, clearTestDialogState } = labTestUpdatesSlice.actions;

export default labTestUpdatesSlice.reducer;